import { DatePicker, Input, Select, Space } from "antd";
import React, { useEffect, useState } from "react";

const { Option } = Select;

export default function ChangableSpace({ setChangableSpaceData }) {
  //state for select
  const [selected, setSelected] = useState(null);
  //width of the select
  const [style, setStyle] = useState({ width: "100%" });

  //changes the state of selected
  const handleChange = (value) => {
    setSelected(value);
    setChangableSpaceData(null);
  };

  //handle date change
  const handleDateChange = (date, dataString) => {
    setChangableSpaceData(dataString);
  };

  //checks for style and changes the width of the "select"
  useEffect(() => {
    if (selected === null) {
      setStyle({ width: "100%" });
    } else {
      setStyle({ width: "30%" });
    }
  }, [selected]);

  //switch for returning proper value
  const returnElement = (value) => {
    switch (value) {
      case "date":
        //returns date
        return (
          <DatePicker
            format="DD.MM.YYYY"
            onChange={handleDateChange}
            style={{
              width: "70%",
            }}
          />
        );
      case "custom":
        //returns custom
        return (
          <Input
            style={{
              width: "70%",
            }}
            onChange={(event) => setChangableSpaceData(event.target.value)}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Space.Compact block>
        <Select style={style} defaultValue={selected} onChange={handleChange}>
          <Option value={null}>Select Option</Option>
          <Option value="date">Date</Option>
          <Option value="custom">Custom Text</Option>
        </Select>
        {returnElement(selected)}
      </Space.Compact>
    </>
  );
}
